import { createFileRoute } from '@tanstack/react-router'

import { QuoteDetailPage } from '@/pages/quotes/[id]/QuoteDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/$id/')({
  component: QuoteDetailPage,
})
